// extracted by mini-css-extract-plugin
module.exports = {"container":"LoyaltyContainer-module--container--1e8e49"};